import Google from '../../assets/img/google.svg'
import Meta from '../../assets/img/meta.svg'
import Microsoft from '../../assets/img/microsoft.svg'
import GTM from '../../assets/img/google-tag-manager.svg'
import { ImgHTMLAttributes, SVGProps } from 'react'

const GoogleIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
	return (
		<img
			src={Google}
			alt="Google"
			className="text-white w-5 h-5"
			data-testid="google-icon"
			{...props}
		/>
	)
}

const MetaIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
	return (
		<img
			src={Meta}
			alt="Meta"
			className="text-white w-5 h-5"
			data-testid="meta-icon"
			{...props}
		/>
	)
}

const GtmIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
	return (
		<img
			src={GTM}
			alt="goggle-tag-manager"
			className="text-white w-5 h-5"
			data-testid="meta-icon"
			{...props}
		/>
	)
}

const BingIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
	return (
		<img src={Microsoft} alt="Microsoft" className="text-white w-5 h-5" {...props} />
	)
}

const MoneyWaveIcon = ({ className = '', color = 'currentColor' }: {className: string, color: string} ) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="35"
			height="28"
			className={className}
			viewBox="0 0 35 28"
			fill={color}
		>
			<path d="M17.875 11.6875C16.5978 11.6875 15.5625 12.7228 15.5625 14C15.5625 15.2772 16.5978 16.3125 17.875 16.3125C19.1522 16.3125 20.1875 15.2772 20.1875 14C20.1875 12.7228 19.1522 11.6875 17.875 11.6875Z" />
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M25.5833 0.125C22.2488 0.125 19.3575 0.961292 16.8435 1.73484L16.374 1.87962C13.999 2.61282 12.07 3.20833 10.1667 3.20833C8.80101 3.20833 7.58098 3.06315 6.5538 2.86579L6.50532 2.85648C5.75283 2.71188 5.12085 2.59044 4.62973 2.52552C4.19887 2.46857 3.5604 2.40087 2.97652 2.60633C2.67051 2.71401 2.33952 2.86761 2.02658 3.12614C1.71364 3.38468 1.50035 3.68074 1.33686 3.96094C1.03656 4.47562 0.974044 5.05896 0.946327 5.47612C0.916634 5.92303 0.916652 6.49145 0.916672 7.14738L0.916669 23.7906C0.916572 24.0946 0.916458 24.4555 1.10004 24.9637C1.19122 25.2162 1.34137 25.4599 1.42805 25.5929C1.51474 25.7258 1.67711 25.9616 1.87127 26.1469C1.99682 26.2667 2.13998 26.3934 2.3114 26.5059C2.47951 26.6163 2.63264 26.6833 2.69947 26.7126L2.71163 26.718C3.9754 27.2754 6.2423 27.875 10.1667 27.875C13.5013 27.875 16.3925 27.0387 18.9065 26.2652L19.376 26.1204C21.751 25.3872 23.68 24.7917 25.5833 24.7917C26.949 24.7917 28.169 24.9368 29.1962 25.1342L29.2447 25.1435C29.9972 25.2881 30.6292 25.4096 31.1203 25.4745C31.5511 25.5314 32.1896 25.5991 32.7735 25.3937C33.0795 25.286 33.4105 25.1324 33.7234 24.8739C34.0364 24.6153 34.2497 24.3193 34.4131 24.0391C34.7135 23.5244 34.776 22.941 34.8037 22.5239C34.8334 22.077 34.8334 21.5086 34.8333 20.8526L34.8333 4.20935C34.8334 3.90541 34.8336 3.54452 34.65 3.03625C34.5588 2.78381 34.4086 2.54012 34.322 2.40714C34.2353 2.27415 34.0729 2.03842 33.8787 1.85312C33.7532 1.7333 33.61 1.60655 33.4386 1.49406C33.2705 1.38374 33.1174 1.31664 33.0505 1.28736L33.0384 1.28202C31.7746 0.724564 29.5077 0.125 25.5833 0.125ZM28.6667 9.375C28.6667 8.52356 27.9764 7.83333 27.125 7.83333C26.2736 7.83333 25.5833 8.52356 25.5833 9.375V15.5417C25.5833 16.3931 26.2736 17.0833 27.125 17.0833C27.9764 17.0833 28.6667 16.3931 28.6667 15.5417V9.375ZM12.4792 14C12.4792 11.02 14.895 8.60417 17.875 8.60417C20.855 8.60417 23.2708 11.02 23.2708 14C23.2708 16.98 20.855 19.3958 17.875 19.3958C14.895 19.3958 12.4792 16.98 12.4792 14ZM8.625 10.9167C9.47644 10.9167 10.1667 11.6069 10.1667 12.4583V18.625C10.1667 19.4764 9.47644 20.1667 8.625 20.1667C7.77356 20.1667 7.08333 19.4764 7.08333 18.625V12.4583C7.08333 11.6069 7.77356 10.9167 8.625 10.9167Z"
			/>
		</svg>
	)
}

const CoinIcon = ({ className = '', color = 'currentColor' }: {className: string, color: string} ) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 35 34"
			className={className}
			fill={color}
		>
			<path d="M12.75 6.20841C12.2531 6.20841 11.7616 6.23193 11.2768 6.2779C13.3992 2.55317 17.4063 0.041748 22 0.041748C28.8115 0.041748 34.3333 5.56357 34.3333 12.3751C34.3333 16.9688 31.8219 20.9759 28.0972 23.0983C28.1432 22.6134 28.1667 22.122 28.1667 21.6251C28.1667 13.1107 21.2644 6.20841 12.75 6.20841Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.416672 21.6251C0.416672 15.7663 4.50187 10.8616 9.97916 9.60424C10.8698 9.39977 11.7973 9.29175 12.75 9.29175C19.5615 9.29175 25.0833 14.8136 25.0833 21.6251C25.0833 22.5778 24.9753 23.5053 24.7708 24.3959C23.5135 29.8732 18.6088 33.9584 12.75 33.9584C5.93849 33.9584 0.416672 28.4366 0.416672 21.6251ZM13.4775 15.6408C13.9787 15.9091 14.2917 16.4315 14.2917 17.0001V23.9376H15.0625C15.9139 23.9376 16.6042 24.6278 16.6042 25.4792C16.6042 26.3307 15.9139 27.0209 15.0625 27.0209H10.4375C9.58607 27.0209 8.89584 26.3307 8.89584 25.4792C8.89584 24.6278 9.58607 23.9376 10.4375 23.9376H11.2083V19.8769C10.51 20.281 9.60856 20.0776 9.15476 19.3969C8.68247 18.6885 8.8739 17.7313 9.58234 17.259L11.8948 15.7173C12.3679 15.402 12.9762 15.3726 13.4775 15.6408Z"
			/>
		</svg>
	)
}

const BuildingIcon = ({ className = '', color = 'currentColor' }: {className: string, color: string} ) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			xmlns="http://www.w3.org/2000/svg"
			fill={color}
			className={className}
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M15.3557 0.632881C15.5349 0.617165 15.7151 0.617165 15.8944 0.632881C16.1005 0.65096 16.2971 0.694949 16.4532 0.729871L27.944 3.28343C28.2529 3.35204 28.5601 3.42026 28.8197 3.4983C29.1095 3.58541 29.4394 3.71197 29.7607 3.94345C30.2144 4.27037 30.5708 4.71457 30.7915 5.22847C30.9477 5.59233 30.9997 5.94175 31.0219 6.24355C31.0418 6.51397 31.0417 6.82859 31.0417 7.14509V8.95787C31.0417 9.34684 31.0418 9.72578 31.0155 10.0466C30.9868 10.399 30.9188 10.8148 30.7056 11.2333C30.41 11.8135 29.9383 12.2851 29.3581 12.5808C28.9397 12.794 28.5239 12.8619 28.1714 12.8907C28.1029 12.8963 28.0317 12.9007 27.9583 12.9042V22.1795C28.0317 22.1829 28.1029 22.1873 28.1714 22.1929C28.5239 22.2217 28.9397 22.2897 29.3581 22.5029C29.9383 22.7985 30.41 23.2702 30.7056 23.8503C30.9188 24.2688 30.9868 24.6846 31.0155 25.037C31.0418 25.3578 31.0417 25.7369 31.0417 26.1258V27.458C31.0417 27.8469 31.0418 28.2258 31.0155 28.5466C30.9868 28.899 30.9188 29.3148 30.7056 29.7333C30.41 30.3134 29.9383 30.7851 29.3581 31.0807C28.9397 31.2939 28.5239 31.3619 28.1714 31.3907C27.8505 31.4169 27.4716 31.4168 27.0825 31.4168H4.16749C3.7784 31.4168 3.39948 31.4169 3.07856 31.3907C2.72615 31.3619 2.31031 31.2939 1.89187 31.0807C1.3117 30.7851 0.840009 30.3134 0.544399 29.7333C0.331191 29.3148 0.263253 28.899 0.23446 28.5466C0.20824 28.2257 0.208286 27.8467 0.208332 27.4576L0.208332 26.126C0.208286 25.7369 0.208241 25.3579 0.23446 25.037C0.263254 24.6846 0.331191 24.2688 0.5444 23.8503C0.840009 23.2702 1.3117 22.7985 1.89187 22.5029C2.31031 22.2897 2.72615 22.2217 3.07857 22.1929C3.14711 22.1873 3.21829 22.1829 3.29166 22.1795V12.9042C3.21829 12.9007 3.14711 12.8963 3.07856 12.8907C2.72615 12.8619 2.31031 12.794 1.89187 12.5808C1.3117 12.2851 0.840009 11.8135 0.544399 11.2333C0.331191 10.8148 0.263253 10.399 0.23446 10.0466C0.208241 9.72568 0.208286 9.34674 0.208332 8.95765L0.208333 7.14509C0.208294 6.82859 0.208255 6.51397 0.228116 6.24355C0.250282 5.94175 0.302284 5.59233 0.458547 5.22847C0.679244 4.71457 1.03556 4.27037 1.48935 3.94345C1.81065 3.71197 2.14047 3.58541 2.43028 3.4983C2.68995 3.42025 2.99709 3.35204 3.30605 3.28342L14.7968 0.72987C14.9529 0.694949 15.1495 0.65096 15.3557 0.632881ZM6.37499 12.9168V22.1668H10.2292V12.9168H6.37499ZM13.3125 12.9168V22.1668H17.9375V12.9168L13.3125 12.9168ZM21.0208 12.9168V22.1668H24.875V12.9168H21.0208Z"
			/>
		</svg>
	)
}

/**
 * Figma "Delete contact" (Billing modals — DS rebuild). The solid Trash01 —
 * @untitled-ui/icons-react only ships the stroke variants, so this is the
 * exported asset with its fill tokenised to `currentColor`.
 */
const Trash01SolidIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 20 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.16146 7.44128e-07H10.8385C11.3657 -1.54898e-05 11.8205 -2.9495e-05 12.195 0.0305728C12.5904 0.0628738 12.9836 0.13419 13.362 0.326984C13.9265 0.614604 14.3854 1.07355 14.673 1.63803C14.8658 2.01641 14.9371 2.40963 14.9694 2.80498C14.9969 3.14075 14.9997 3.54097 15 4H19C19.5523 4 20 4.44772 20 5C20 5.55229 19.5523 6 19 6H18V16.2413C18 17.0462 18 17.7106 17.9558 18.2518C17.9099 18.8139 17.8113 19.3306 17.564 19.816C17.1805 20.5686 16.5686 21.1805 15.816 21.564C15.3306 21.8113 14.8139 21.9099 14.2518 21.9558C13.7106 22 13.0463 22 12.2413 22H7.75868C6.95372 22 6.28936 22 5.74818 21.9558C5.18608 21.9099 4.66937 21.8113 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2.18868 19.3306 2.09012 18.8139 2.04419 18.2518C1.99998 17.7106 1.99999 17.0463 2 16.2413L2 6H1C0.447715 6 0 5.55229 0 5C0 4.44772 0.447715 4 1 4H5.00003C5.00031 3.54097 5.00314 3.14075 5.03057 2.80498C5.06287 2.40963 5.13419 2.01641 5.32698 1.63803C5.6146 1.07355 6.07354 0.614604 6.63803 0.326984C7.01641 0.13419 7.40963 0.0628738 7.80497 0.0305728C8.17953 -2.94931e-05 8.63434 -1.54898e-05 9.16146 7.44128e-07ZM8 9.5C8.55229 9.5 9 9.94772 9 10.5V15.5C9 16.0523 8.55229 16.5 8 16.5C7.44772 16.5 7 16.0523 7 15.5V10.5C7 9.94772 7.44772 9.5 8 9.5ZM13 10.5C13 9.94772 12.5523 9.5 12 9.5C11.4477 9.5 11 9.94772 11 10.5V15.5C11 16.0523 11.4477 16.5 12 16.5C12.5523 16.5 13 16.0523 13 15.5V10.5Z"
			fill="currentColor"
		/>
	</svg>
)

export {
	BingIcon,
	GoogleIcon,
	MetaIcon,
	GtmIcon,
	MoneyWaveIcon,
	CoinIcon,
	BuildingIcon,
	Trash01SolidIcon
}
